import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mpgPercentage',
    standalone: false
})
export class MpgPercentagePipe implements PipeTransform {

  transform(mpg: number, totalMpg: number, decimalPlace?: number): unknown {
    if (mpg && totalMpg) {
      let calculatedMpg = (mpg / totalMpg) * 100;
      if (Number.isInteger(calculatedMpg)) {
        return calculatedMpg;
      }
      return parseFloat(calculatedMpg.toString()).toFixed(decimalPlace || 0)
    }
    return 0;
  }

}
